module.exports = __webpack_public_path__ + "img/logo-sign-up.36274cd.png";